module.exports = __webpack_public_path__ + "img/4.81b112a0.svg";